class SearchTabsComponent extends HTMLElement {
  constructor() {
    super();
    this.tabNavItems = this.querySelectorAll('[data-vf-search-tabs-nav-item]');
    this.searchResultsContainer = document.getElementById('search-results-container');
  }

  connectedCallback() {
    this.baseSearchParams = new URLSearchParams(window.location.search);
    this.tabNavItems.forEach(item => {
      item.addEventListener('click', this.handleTabNavItemClick.bind(this));
    });

    this.addEventListener('change', this.handleSortChange.bind(this));
    this.syncActiveTabFromUrl();
    this.setResultsCounts();

    // If someone lands on a URL with sorting but no explicit type,
    // treat it as a product-only view.
    if (this.baseSearchParams.get('sort_by') && !this.baseSearchParams.get('type')) {
      this.loadTab('product');
    }
  }

  handleTabNavItemClick(event) {
    const searchTypeValue = event.currentTarget.dataset.searchType;
    this.loadTab(searchTypeValue);
  }

  handleSearchResultsResponse(event) {
    const searchResults = JSON.parse(event.target.response)['search-results'];
    const html = new DOMParser().parseFromString(searchResults, 'text/html');
    this.searchResultsContainer.innerHTML = html.querySelector('#search-results').innerHTML;
    this.tabNavItems.forEach(item => {
      item.classList.remove('loading');
    });
  }

  handleSortChange(event) {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!select.matches('[data-vf-search-sort-select]')) return;

    const sortBy = select.value;
    if (sortBy) {
      this.baseSearchParams.set('sort_by', sortBy);
    } else {
      this.baseSearchParams.delete('sort_by');
    }

    // Sorting should always apply to product results. If the user is on "All results",
    // switch them to the products tab and load sorted products.
    this.baseSearchParams.set('type', 'product');
    this.updateUrlParams();
    this.loadTab('product', { preserveSort: true });
  }

  setResultsCounts() {
    this.tabNavItems.forEach(item => {
      const searchType = this.getSearchTypeParam(item.dataset.searchType);
      const request = new XMLHttpRequest();
      request.addEventListener('load', (event) => {
        try {
          this.handleSearchResultsCountResponse(event, item);
        } catch (error) {
          console.error('Error rendering search results', error);
        }
      });
      request.open('GET', this.buildSectionsUrl('search-results-count', searchType), true);
      request.send();
    });
  }

  handleSearchResultsCountResponse(event, item) {
    const searchResultsCount = JSON.parse(event.target.response)['search-results-count'];
    const html = new DOMParser().parseFromString(searchResultsCount, 'text/html');
    const resultsCount = item.querySelector('[data-results-count]');
    resultsCount.innerHTML = html.querySelector('#search-results-count').innerHTML;
    if (resultsCount.innerHTML == '0') {
      item.disabled = true;
    } else {
      item.disabled = false;
    }
  }

  buildSectionsUrl(sectionId, searchType) {
    const params = new URLSearchParams(this.baseSearchParams.toString());
    params.set('sections', sectionId);

    if (searchType) {
      params.set('type', searchType);
    } else {
      params.delete('type');
    }

    return `${window.location.pathname}?${params.toString()}`;
  }

  getSearchTypeParam(searchTypeValue = '') {
    const normalized = searchTypeValue.replaceAll('_', ',');
    return normalized === 'all' ? '' : normalized;
  }

  loadTab(searchTypeValue, options = {}) {
    const searchType = this.getSearchTypeParam(searchTypeValue);

    // Keep URL + internal params in sync with the active tab.
    // Reset sorting whenever navigating tabs (including navigating *to* Products),
    // but preserve it when the sort dropdown itself triggered the navigation.
    const preserveSort = Boolean(options.preserveSort);
    if (!preserveSort) {
      this.baseSearchParams.delete('sort_by');
    }
    if (searchType) {
      this.baseSearchParams.set('type', searchType);
    } else {
      this.baseSearchParams.delete('type');
    }
    this.updateUrlParams();

    const request = new XMLHttpRequest();
    request.addEventListener('load', (event) => {
      try {
        this.handleSearchResultsResponse(event);
      } catch (error) {
        console.error('Error rendering search results', error);
      }
    });
    request.open('GET', this.buildSectionsUrl('search-results', searchType), true);
    request.send();

    this.tabNavItems.forEach(item => {
      item.classList.remove('active');
      item.classList.add('loading');
    });
    const activeTab = Array.from(this.tabNavItems).find(item => item.dataset.searchType === searchTypeValue);
    if (activeTab) activeTab.classList.add('active');
  }

  updateUrlParams() {
    try {
      const params = new URLSearchParams(this.baseSearchParams.toString());
      const qs = params.toString();
      const next = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
      window.history.replaceState({}, '', next);
    } catch {
      // no-op (e.g. older browsers / restricted environments)
    }
  }

  syncActiveTabFromUrl() {
    const type = this.baseSearchParams.get('type') || '';
    let searchTypeValue = 'all';

    if (!type) {
      searchTypeValue = 'all';
    } else if (type === 'product') {
      searchTypeValue = 'product';
    } else if (type.includes('article') || type.includes('page')) {
      searchTypeValue = 'article_page';
    }

    this.tabNavItems.forEach(item => item.classList.remove('active'));
    const activeTab = Array.from(this.tabNavItems).find(item => item.dataset.searchType === searchTypeValue);
    if (activeTab) activeTab.classList.add('active');
  }
}

customElements.define('search-tabs-component', SearchTabsComponent);
